// extracted by mini-css-extract-plugin
module.exports = {"parent":"Law_parent_w70jN","section":"Law_section_2SUBP"};